import { render, staticRenderFns } from "./SearchUser.vue?vue&type=template&id=459a660c&scoped=true&"
import script from "./SearchUser.vue?vue&type=script&lang=js&"
export * from "./SearchUser.vue?vue&type=script&lang=js&"
import style0 from "./SearchUser.vue?vue&type=style&index=0&id=459a660c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a660c",
  null
  
)

export default component.exports